import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aecf34f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "dimmer",
  id: "dimmer_loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dimmer-inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dimmer-icon" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner progress-spinner-active" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Caricamento...")
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import {Dimmer} from 'bootstrap-italia'
import {onMounted, watch} from "vue";
import {useLoadingSpinnerStore} from "@/stores/loadingSpinner";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingPage',
  setup(__props) {

// @ts-ignore
onMounted(() => {
  const myDimmer = document.getElementById('dimmer_loading')
  const dimmer = new Dimmer(myDimmer)
  dimmer.hide()

  const loadingSpinnerStore = useLoadingSpinnerStore();
  watch(loadingSpinnerStore.loading, (value: Map<string, boolean>) => {
    if(!!dimmer){
      const inLoading = [...value.values()].some((el) => el);
      inLoading ? dimmer.show() : dimmer.hide();
    }
  }, {deep: true})

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})